import { LoadingProps } from "./types"
import React from "react"
import { LoadingCore } from "./core"

const Loading: React.FC<LoadingProps> = (props) => <LoadingCore {...props} />

export default Loading
